export type EnrolmentComparison = {
  title: string
  self: string
  programme: string
}

export type EnrolmentComparisonsTable = {
  selfTitle: string
  programmeTitle: string
  comparisons: EnrolmentComparison[]
}

const comparisonDetails: EnrolmentComparison[] = [
  {
    title: 'How does it work?',
    self: 'You can purchase our course, and learn at your own pace.',
    programme: `Or you can join our workforce enhancement initiatives where we:<br/>
            <ul>
                <li>Train you with in-demand skllls, and</li>
                <li>Get you a career placement with our top hiring partners</li>
            </ul>`
  },
  {
    title: 'Is there an application process?',
    self: `<b class='green'>Yes</b>
            You will be assessed by our instructors.`,
    programme: `<b class='green'>Yes</b>
            You will be assessed by our instructors, and any further interviews with our hiring partners.`
  },
  {
    title: 'Can anyone apply?',
    self: `<b class='green'>Yes</b>
          Anyone can apply to this course and start learning.`,
    programme: `<b class='red'>No</b>
          Each initiatives have their own requirements and eligibility, for example age, location, nationality etc.`
  },
  {
    title: 'Do I have to pay for this course?',
    self: `<b class='red'>Yes</b>
            You have the flexible option to pay upfront at a discount, or to pay monthly.`,
    programme: `<b class='green'>No</b>
            This course wlll be <u>free of charge</u> if you enrol through our career initiatives.`
  },
  {
    title: 'Will I get paid?',
    self: `<b class='red'>No</b>`,
    programme: `<b class='green'>Yes, for some of our initiatives.</b>
            Some of our career initiatives pay our students a monthly salary throughout the programme.`
  },
  {
    title: 'How long will this take?',
    self: 'Up to you. <br/>You can finish your study whenever, and wherever you want.',
    programme:
      'Each of our career programmes have their own timelines, ranging from <b>three to nine months.</b>'
  },
  {
    title: 'Will I get a certificate upon completion?',
    self: `<b class='green'>Yes</b>`,
    programme: `<b class='green'>Yes</b>`
  },
  {
    title: 'Will I get access to live tutorial sessions and marked projects? ',
    self: `<b class='green'>Yes</b>`,
    programme: `<b class='green'>Yes</b>`
  },
  {
    title: 'Do I get career support?',
    self: `<b class='green'>Yes</b>`,
    programme: `<b class='green'>Yes</b>
            We will also conduct in-depth CV workshops and interview seminars.`
  }
]

export const enrolmentComparisons: EnrolmentComparisonsTable = {
  selfTitle: 'Self-paced study',
  programmeTitle: 'Sponsored programmes',
  comparisons: comparisonDetails
}
